


import {nanoid} from "nanoid";

const patternData = [
    {
        name: 'Default 17/16',
        data: [
            {
                id: nanoid(),
                length: 3,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 2,
                base: 2,
                silent: false
            },
            {
                id: nanoid(),
                length: 2,
                base: 2,
                silent: false
            },
            {
                id: nanoid(),
                length: 3,
                base: 2,
                silent: false
            }
        ]
    },
    {
        name: 'Chutzpan',
        data: [
            {
                id: nanoid(),
                length: 1,
                base: 2,
                silent: false
            },
            {
                id: nanoid(),
                length: 1,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 1,
                base: 2,
                silent: false
            },
            {
                id: nanoid(),
                length: 1,
                base: 2,
                silent: false
            },
            {
                id: nanoid(),
                length: 1,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 1,
                base: 2,
                silent: false
            },
            {
                id: nanoid(),
                length: 6,
                base: 4,
                silent: false
            }
        ],
    },


    {
        name: 'Tomas 11/8',
        data: [
            {
                id: nanoid(),
                length: 2,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 3,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 2,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 3,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 2,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 3,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 2,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 2,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 2,
                base: 1,
                silent: false
            },
            {
                id: nanoid(),
                length: 1,
                base: 1,
                silent: false
            }
        ]
   // }



    }
]

export default patternData